import { CopyOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { ReactNode, useState } from 'react';

type Props = {
	children?: ReactNode;
	text?: string;
};

const CopyButton = ({ children = 'Скопировать', text = '' }: Props) => {
	const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

	const showTooltip = () => {
		setIsTooltipOpen(true);

		setTimeout(() => {
			setIsTooltipOpen(false);
		}, 1000);
	};

	return (
		<Tooltip open={isTooltipOpen} title="Скопировано">
			<Button
				icon={<CopyOutlined />}
				onClick={() => {
					showTooltip();
					navigator.clipboard.writeText(text);
				}}
			>
				{children}
			</Button>
		</Tooltip>
	);
};

export default CopyButton;
